<div class="panel panel-default panel--shadow margin-bottom-48" *ngIf="showFlyBackSection">
  <div class="panel-body">
    <div class="flex-always flex--align-start flex--space-between margin-bottom-16">
      <h3 class="margin-top-0 text-dark-blue"
        [innerHTML]="appCopy.panelHeader['tranvelHandsFreeTitle'+selectedLanguage]">
        Travel hands free on your retur
      </h3>
    </div>

    <!-- if CCD -->
    <p
      [innerHTML]="appCopy.panelHeader['travelHandsFreeDescriptionArrival'+selectedLanguage].replace('%s', arrivalAirport.airportCode)">
      The Arrival service is available when you return to {{arrivalAirport.airportCode}}. Confirm your return flight and
      have your bags delivered after landing.
    </p>

    <div class="flight-item panel margin-top-24" *ngIf="selectedFlight">
      <div class="panel-body flex-always">
        <div [ngClass]="
            'hidden-xs airline-logo airline-logo--' +
            selectedFlight.flightStatusDetails[0].airlineCode.replace(
              '*',
              ''
            )
          "></div>
        <div class="flex-lg flex__item--grow">
          <div class="flex__item--equal">
            <p style="text-transform: none">
              {{ selectedFlight.flightStatusDetails[0].airlineName }}
            </p>
            <p>
              <span class="hidden-xs">{{
                appCopy.panelHeader["titleFlight" + selectedLanguage]
                }} </span>{{
              selectedFlight.flightStatusDetails[0]
              .airlineCodeDisplayName
              }}{{ selectedFlight.flightStatusDetails[0].flightNumber }}
            </p>
          </div>
          <div class="flex__item--equal" *ngIf="selectedFlight.flightStatusDetails.length > 1">
            <p class="visible-lg-block">
              {{ appCopy.panelHeader["titleStops" + selectedLanguage] }}
            </p>
            <p class="flex-always text-extra-bold">
              {{
              selectedFlight.flightStatusDetails[0].departureAirport
              .airportCode
              }}
              <ng-container *ngFor="let leg of selectedFlight.flightStatusDetails">
                <span class="leg-divider"></span>
                {{ leg.arrivalAirport.airportCode }}
              </ng-container>
            </p>
          </div>
        </div>
        <!-- <div class="flex-divider margin-right-0 hidden-sm hidden-xs"></div> -->
        <div class="flex-lg flex-md flight-item__departure">
          <p>
            {{ appCopy.panelHeader["titleDeparts" + selectedLanguage] }}
          </p>
          <h4 class="text-extra-bold margin-top-0 margin-bottom-0">
            {{
            selectedFlight.flightStatusDetails[0]
            .departureDateTimeDetails.scheduledDateTimeLocal
            | amDateFormat : "HH:mm"
            }}
          </h4>
        </div>
      </div>
    </div>

    <button type="button" class="btn btn-flight btn-block margin-auto margin-bottom-16 margin-top-24"
      (click)="confirmSelectedFlight()">
      <span>
        {{ appCopy.panelHeader["bookNowText" + selectedLanguage] }}
      </span>
    </button>

    <button type="button" [ngClass]="{ Buttonloading: false }" class="btn btn-ghost border-0 margin-auto"
      (click)="returnToPreviouseStep()" [disabled]="false">
      <span [innerHTML]="appCopy.panelHeader['editReturnFlightButton'+selectedLanguage]">edit return flight</span>
    </button>
  </div>
</div>
